module.exports = __webpack_public_path__ + "static/img/header4.5ac8833.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header4.png
// module id = Ke7A
// module chunks = 1